export class Resume {
    constructor() {
        this.resumeId = null;
        this.sourceTypeId = null;
    }
}
//# sourceMappingURL=resume.js.map